import { Component, Input } from '@angular/core';

import { PromoTypeComponent } from '../../promo-type.component';

/**
 * "the_portrait" view of /promo-type.
 *
 * Flow is unchanged: TEXT CODE still opens the page's #promotiontext modal, which is what
 * raises the keyboard. Only the landing layout is redrawn here — the modal and the keyboard
 * are restyled globally in styles.scss, since both render outside component scope.
 */
@Component({
  selector: 'app-promo-type-portrait',
  templateUrl: './promo-type-portrait.component.html',
  styleUrls: ['./promo-type-portrait.component.scss']
})
export class PromoTypePortraitComponent {

  @Input() host!: PromoTypeComponent;

}
